import React, { useEffect, useState } from "react";
import "../assets/css/shcolars.css";
import axios from "axios";
import configModule from "../../config";
import { FaAngleRight } from "react-icons/fa";
import { useNavigate } from "react-router-dom";
import Footer from "./footer";
import { FaCalendarAlt } from "react-icons/fa";
import dayjs from "dayjs";

function QuestionandAnswer() {
    const [questionandAnswer, setQuestionandAnswer] = useState([]);
    const config = configModule.config();
    const navigate = useNavigate();

    const fetchquestionandAnswer = async () => {
        try {
            const res = await axios.get(
                `${config.apiBaseUrl}/get-queandanswer`,
                {
                    headers: {
                        "x-api-key": config.apichKey,
                    },
                }
            );

            setQuestionandAnswer(res?.data || []);
        } catch (error) {
            console.log(error);
        }
    };

    useEffect(() => {
        fetchquestionandAnswer();
    }, []);

    function decodeHTML(html) {
        const txt = document.createElement("textarea");
        txt.innerHTML = html;
        return txt.value;
    };

    function cleanHTML(html) {
        return html.replace(/<\/?p>/g, "");
    };

    const formatDate = (date) => dayjs(date).format("DD MMM YYYY hh:mm a");

    return (
        <div className="scscholmain-container">
            {/* Banner */}
            <div className="cl-hero-banner" style={{ height: "92px" }}>
                <div className="cl-hero-pattern"></div>
                <div className="cl-hero-text">
                    <h2>QUESTION AND ANSWER</h2>
                </div>

                <span className="breadcrumb-st" > <span className="gotohome-st" onClick={() => navigate("/")} >Home</span> <FaAngleRight className="arrow_icon" /> <b>question and answer</b> </span>
            </div>

            <div className="sccontainer-st">

                <div className="row-mainst">
                    {questionandAnswer.map((item) => (
                        <div className="innerrow-main-st" key={item?.f_id}>
                            <div className="innerrow-mainst">
                                <h5 className="logotext-st">{item?.name?.charAt(0)}</h5>

                                <div className="">
                                    <h5 className="headtitlesc-st">{item?.f_question}</h5>
                                    <p className="ask-stlabel">Asked By {item?.name || '-'} <FaCalendarAlt /> {item?.f_createdOn ? formatDate(item?.f_createdOn) : '-'}</p>
                                    <div
                                        className="overview-text"
                                        dangerouslySetInnerHTML={{
                                            __html: cleanHTML(decodeHTML(item?.ans_answer || ""))
                                        }}
                                    />
                                </div>
                            </div>
                            <div className="voteview-st">
                                <div>
                                    <p className="commvoteview-st">{item?.f_views || 0}</p>
                                    <p>Views</p>
                                </div>
                                <div>
                                    <p className="commvoteview-st">{item?.f_likes || 0}</p>
                                    <p>Votes</p>
                                </div>
                            </div>
                        </div>
                    ))}
                </div>

                {
                    questionandAnswer.length === 0 && (
                        <div className="text-center py-5" style={{ minHeight: "100vh" }}>
                            <h5>No Question and Answer Found</h5>
                        </div>
                    )
                }
            </div >

            <Footer />
        </div >
    );
}

export default QuestionandAnswer;